module.exports = __webpack_public_path__ + "media/images/category/area-8953da4818719d321ea385df9718d16c.svg";